var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolunteers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 89,
    viewBox: "0 0 94 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.05H17.8962V89H0V40.05ZM67.1109 5.5625C70.019 2.1805 74.5378 0 79.1909 0C87.4679 0 93.9553 6.4525 93.9553 14.685C93.9553 24.7865 80.9357 36.49 67.1109 48.95C53.2861 36.4455 40.2665 24.742 40.2665 14.685C40.2665 6.4525 46.7539 0 55.0309 0C59.684 0 64.2028 2.1805 67.1109 5.5625ZM85.0071 66.75H53.6887L44.3379 63.5015L45.8144 59.3185L53.6887 62.3H66.3056C69.2137 62.3 71.585 59.9415 71.585 57.049C71.585 54.8685 70.198 52.9105 68.1399 52.1095L35.6583 40.05H26.8444V80.189L58.1628 89L94 75.65C93.9553 70.755 89.9734 66.75 85.0071 66.75Z",
    fill: "#7D7D7D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolunteers);
export default __webpack_public_path__ + "static/media/volunteers.2d4565510a7cd528344fafe284792167.svg";
export { ForwardRef as ReactComponent };